import axios from 'axios'

import { API_ROUTES } from '../routes'
import { getConnectionUrl } from '../utils'

export const useDownloadAgreement = () => {
  const downloadAgreement = async (id: string) => {
    try {
      const url = getConnectionUrl(API_ROUTES.AGREEMENT_DOWNLOAD)

      const response = await axios.get(url, {
        params: { id },
        responseType: 'blob',
        withCredentials: true,
      })

      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')

      link.href = downloadUrl
      link.setAttribute('download', `agreement-${id}.pdf`)
      document.body.appendChild(link)
      link.click()
      link.remove()

      window.URL.revokeObjectURL(downloadUrl)
    } catch (err) {
      console.log(err instanceof Error ? err.message : 'Failed to download agreement')
    }
  }

  return downloadAgreement
}
